/**
 * @author PoornaChandu
 * @description updated code
 */
import React, { useEffect, useRef, useState } from 'react';
import themeSettings from './Utils/themeSettings.json';
import { StyledComponent, StyledForm } from './CSS/style';
import history from '../../../commons/history';
import { API_BACKUP } from '../../../commons/api';
import { Button, Form, Input, Select, message, DatePicker } from 'antd';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  submitTask,
  SchemasList,
  TablesListBySchema,
  getStorageLocation,
  getMetaData,
  updateTask
} from './Utils/FormCalls';
import dayjs from 'dayjs';

const { Option } = Select;
const APIList = {
  getById: `${API_BACKUP.TasksGetById}`,
  getTables: `${API_BACKUP.TasksGetTablesBySchemas}`,
  createData: `${API_BACKUP.TasksCreate}`,
  updateData: `${API_BACKUP.TasksUpdate}`,
  GetSchemasList: `${API_BACKUP.TasksGetSchemas}`,
  getStorage: `${API_BACKUP.TaskStorage}`
};

const TaskSchedulerDetails = (props) => {
  const navigate = useNavigate();
  const [formObject, setFormObject] = useState({});
  const [tablesList, setTablesList] = useState([]);
  const [schemaList, setSchemaList] = useState([]);
  // const [selectedSchema, setSelectedSchema] = useState('');
  const [userProfile,setUserProfile] = useState(props.userProfile);
  const [translationCache,setTranslationCache] = useState(props.translationCache);
  const hRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const schemaList = await SchemasList(APIList.GetSchemasList);
      setSchemaList(schemaList);

      const path = history.location.pathname.split('/rubus/TaskSchedulerDetails/');
      const Id = path && path[1] ? path[1] : null;

      if (Id !== null) {
        const data = await getMetaData(APIList.getById, 'Id', Id);
        const tablesList = await TablesListBySchema(APIList.getTables, data[0].Schema);

        // setSelectedSchema(data[0].Schema);
        setTablesList(tablesList);

        const formObject = {
          ...data[0],
          StartDate: data[0].StartDate ? dayjs(data[0].StartDate) : null,
          EndDate: data[0].EndDate ? dayjs(data[0].EndDate) : null,
          ScheduledTime: data[0].ScheduledTime ? dayjs(data[0].ScheduledTime) : null
        };

        if (hRef.current) {
          hRef.current.setFieldsValue({
            ...formObject,
            DataStorageLocation: data[0].StorageLocation || ''
          });
        }
        setFormObject(formObject);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.translationCache !== translationCache
    ) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }  }, [userProfile, translationCache]);

  const onFormSubmit = () => {
    hRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue()
        };
        if (values && values.Id === undefined) {
          const response = await submitTask(APIList.createData, values);
          message.success(response && response.message ? translation(response.message) : '');
          navigate('/rubus/TaskScheduler');
        } else {
          const response = await updateTask(APIList.updateData, values, values.Id);
          if (response && response.message) {
            message.success(translation(response.message));
          }
          navigate('/rubus/TaskScheduler');
        }
      })
      .catch(() => {});
  };

  const resetFields = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setFormObject({});
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onSchemaChange = async (values) => {
    if (hRef.current) {
      hRef.current.setFieldsValue({ TableName: [] });
    }
    const tablesList = await TablesListBySchema(APIList.getTables, values);
    const storageLocation = await getStorageLocation(APIList.getStorage, values);
    const updatedFormObject = {
      ...formObject,
      DataStorageLocation: storageLocation[0]?.Value || ''
    };
    if (hRef.current) {
      hRef.current.setFieldsValue(updatedFormObject);
    }
    // setSelectedSchema(values);
    setTablesList(tablesList);
    setFormObject(updatedFormObject);
  };

  const validateMessages = {
    required: translation('${label}') + translation('is required!')
  };

  const formItemLayout = { width: '100%', flex: '50%' };

  return (
    <StyledComponent
      theme={themeSettings}
      style={{
        padding: '30px 30px',
        minHeight: window.innerHeight - 143,
        margin: '5px'
      }}
    >
      <div>
        <Button
          type="primary"
          onClick={() => {
            navigate('/rubus/TaskScheduler');
          }}
        >
          Go Back
        </Button>
      </div>
      <StyledForm
        name="taskSchedulerDetails"
        ref={hRef}
        autoComplete="off"
        initialValues={formObject}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        onFinish={onFormSubmit}
        validateMessages={validateMessages}
        wrapperCol={{ flex: 1 }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
          <Form.Item name="Id"></Form.Item>
          <Form.Item
            label={translation('Name')}
            name="TaskName"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input
              style={{ width: '400px' }}
              placeholder={translation('Please Enter Name')}
            />
          </Form.Item>
          <Form.Item
            name="StartDate"
            label={translation('Start Date')}
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              style={{ width: '400px' }}
              allowClear={false}
              showTime={{ format: 'HH:mm:ss' }}
              format="YYYY-MM-DD HH:mm:ss"
              disabledDate={(d) => !d || d.isAfter(hRef.current?.getFieldValue('EndDate'))}
            />
          </Form.Item>
          <Form.Item
            name="EndDate"
            label={translation('End Date')}
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              style={{ width: '400px' }}
              allowClear={false}
              showTime={{ format: 'HH:mm:ss' }}
              format="YYYY-MM-DD HH:mm:ss"
              disabledDate={(d) => !d || d.isBefore(hRef.current?.getFieldValue('StartDate'))}
            />
          </Form.Item>
          <Form.Item
            name="ScheduledTime"
            label={translation('Scheduled Time')}
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              style={{ width: '400px' }}
              allowClear={false}
              showTime={{ format: 'HH:mm:ss' }}
              format="YYYY-MM-DD HH:mm:ss"
              // minDate={moment().toDate()}
                // disabled={ButtonKey === 'stop' ? true : false}
                // onOk={(date) => this.handleRealTimeDateInputChange(date)}
                // disabledDate={
                //   (d) =>
                //     !d ||
                //     d.isBefore(
                //       this.hRef.current &&
                //         this.hRef.current !== null &&
                //         this.hRef.current.getFieldValue() &&
                //         this.hRef.current.getFieldValue('StartDate')
                //         ? moment(
                //             this.hRef.current.getFieldValue() &&
                //               this.hRef.current.getFieldValue('StartDate')
                //           ).format('YYYY-MM-DD HH:mm:ss')
                //         : ''
                //     )
                //   //  ||
                //   // d.isBefore(moment().format('YYYY-MM-DD HH:mm:ss'))
                // }
            />
          </Form.Item>
          <Form.Item
            label={translation('Schema')}
            name="Schema"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Select
              style={{ width: '400px' }}
              placeholder={translation('Please Select Schema')}
              onChange={onSchemaChange}
            >
              {schemaList && Array.isArray(schemaList) && schemaList.map((schema) => (
                <Option value={schema.Value} key={schema.Key}>
                  {schema.Key}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Table Selection')}
            name="TableName"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Select
              mode="multiple"
              style={{ width: '400px' }}
              placeholder={translation('Please Select Table')}
            >
              {tablesList && Array.isArray(tablesList) && tablesList.map((table) => (
                <Option value={table.Value} key={table.Key}>
                  {table.Value}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Data Storage Location')}
            name="DataStorageLocation"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input
              disabled={true}
              style={{ width: '400px' }}
              placeholder={translation('Autopopulated based on schema selection')}
            />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button
              style={{ marginRight: 8 }}
              theme={themeSettings}
              type="primary"
              htmlType="submit"
              data-testid="submitButton"
            >
              {translation('Submit')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginRight: 8 }}
              theme={themeSettings}
              type="primary"
              onClick={resetFields}
            >
              {translation('Cancel')}
            </Button>
          </Form.Item>
        </div>
      </StyledForm>
    </StyledComponent>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(TaskSchedulerDetails);